module.exports = __webpack_public_path__ + "img/hand.39ee96b7.svg";